import React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { MapPin, Mail, Instagram, Phone, MessageCircle } from "lucide-react"
import * as styles from "../styles/footer.module.css"
import { trackWhatsAppClick, trackPhoneClick, trackEmailClick, trackInstagramClick } from "../utils/useAnalytics"

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        {/* Brand */}
        <div className={styles.footerBrand}>
          <StaticImage
            src="../images/logo-bianco.png"
            alt="Dott.ssa Lisa Parri"
            height={40}
            placeholder="none"
            quality={95}
            className={styles.footerLogo}
          />
          <h3>Dott.ssa Lisa Parri</h3>
          <span className={styles.footerSubtext}>Biologa Nutrizionista</span>
          <p>
            Biologa nutrizionista. Aiuto le persone a migliorare la propria
            composizione corporea e salute attraverso un metodo scientifico
            personalizzato.
          </p>
          <div className={styles.footerSocial}>
            <a
              href="https://www.instagram.com/dott.ssa_lisa_parri/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              onClick={trackInstagramClick}
            >
              <Instagram size={16} />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className={styles.footerSection}>
          <h4>Link Rapidi</h4>
          <ul>
            <li><Link to="/servizi">Servizi</Link></li>
            <li><Link to="/chi-sono">Chi Sono</Link></li>
            <li><Link to="/blog/">Blog</Link></li>
            <li><Link to="/contatti">Contatti</Link></li>
            <li>
              <span className={styles.prenotaLabel}>Prenota Visita</span>
              <ul className={styles.prenotaSub}>
                <li><a href="https://wa.me/393886591205" target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick}><MessageCircle size={13} style={{ marginRight: '0.35rem', verticalAlign: 'middle' }} />WhatsApp</a></li>
                <li><a href="tel:+393886591205" onClick={trackPhoneClick}><Phone size={13} style={{ marginRight: '0.35rem', verticalAlign: 'middle' }} />Telefono</a></li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Contatti */}
        <div className={styles.footerSection}>
          <h4>Contatti</h4>
          <div className={styles.contactItem}>
            <p><MapPin size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '0.4rem' }} /><a href="https://maps.google.com/?q=Via+Flaminia+Sud,+km+189/200,+Gualdo+Tadino+PG" target="_blank" rel="noopener noreferrer">Via Flaminia Sud, km 189/200, Gualdo Tadino (PG)</a></p>
          </div>
          <div className={styles.contactItem}>
            <p><Mail size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '0.4rem' }} /><a href="mailto:nutrizionistalisa@outlook.it" onClick={trackEmailClick}>nutrizionistalisa@outlook.it</a></p>
          </div>
          <div className={styles.contactItem}>
            <p><Phone size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '0.4rem' }} /><a href="tel:+393886591205" onClick={trackPhoneClick}>+39 388 659 1205</a></p>
          </div>
          <div className={styles.contactItem}>
            <p><MessageCircle size={14} style={{ display: 'inline', verticalAlign: 'middle', marginRight: '0.4rem' }} /><a href="https://wa.me/393886591205" target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick}>Scrivimi su WhatsApp</a></p>
          </div>
        </div>
      </div>

      <div className={styles.footerBottom}>
        <p>
          © {new Date().getFullYear()} Dott.ssa Lisa Parri — Biologa
          Nutrizionista. Tutti i diritti riservati.
        </p>
        <div className={styles.footerBottomLinks}>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/termini">Termini di Servizio</Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer
